import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export const OrganizationLoadingScreen: React.FC = () => {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
      }}
    >
      <CircularProgress size={60} />
      <Typography variant="h6" sx={{ mt: 3, color: '#666' }}>
        Loading organization...
      </Typography>
    </Box>
  );
};

export const OrganizationErrorScreen: React.FC<{ error: string }> = ({ error }) => {
  return (
    <Box
      sx={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f5f5f5',
        padding: 4,
      }}
    >
      <Typography variant="h4" color="error" gutterBottom>
        Organization Not Found
      </Typography>
      <Typography variant="body1" color="textSecondary" sx={{ mb: 4, textAlign: 'center' }}>
        {error}
      </Typography>
      <Typography variant="body2" color="textSecondary">
        Please check the URL and try again.
      </Typography>
    </Box>
  );
};
